var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/product-quantity-dropdown.j2"] = require( "macros/product-quantity-dropdown.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-quantity.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "product/templates/product-quantity.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("hasErrors")) {
var t_4 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
env.getTemplate("macros/product-quantity-dropdown.j2", false, "product/templates/product-quantity.j2", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
if(t_6.hasOwnProperty("productQuantityDropdown")) {
var t_9 = t_6.productQuantityDropdown;
} else {
cb(new Error("cannot import 'productQuantityDropdown'")); return;
}
context.setVariable("productQuantityDropdown", t_9);
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView") && runtime.contextOrFrameLookup(context, frame, "registry")) {
var t_10;
t_10 = "g-product-quantity--registry";
frame.set("gridClass", t_10, true);
if(frame.topLevel) {
context.setVariable("gridClass", t_10);
}
if(frame.topLevel) {
context.addExport("gridClass", t_10);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView")) {
var t_11;
t_11 = "g-product-quantity--quickshop";
frame.set("gridClass", t_11, true);
if(frame.topLevel) {
context.setVariable("gridClass", t_11);
}
if(frame.topLevel) {
context.addExport("gridClass", t_11);
}
;
}
else {
var t_12;
t_12 = "g-product-quantity--not-quickshop";
frame.set("gridClass", t_12, true);
if(frame.topLevel) {
context.setVariable("gridClass", t_12);
}
if(frame.topLevel) {
context.addExport("gridClass", t_12);
}
;
}
;
}
var t_13;
t_13 = (function() {
var output = "";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += "quantity-selection-quickshop";
;
}
else {
output += "quantity-selection-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productSlug"), env.opts.autoescape);
;
}
;
return output;
})()
;
frame.set("quantityDropdownId", t_13, true);
if(frame.topLevel) {
context.setVariable("quantityDropdownId", t_13);
}
if(frame.topLevel) {
context.addExport("quantityDropdownId", t_13);
}
output += "<div class=\"g-product-quantity ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "gridClass"), env.opts.autoescape);
output += " c-product-quantity js-product-quantity\" data-qa-quantity>\n\n\t<div class=\"c-form__field c-product-quantity__field\">\n\n\t    <label class=\"c-form__label c-product-quantity__label\" for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "quantityDropdownId"), env.opts.autoescape);
output += "\">\n\n            ";
output += runtime.suppressValue((lineno = 25, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showDesiredQty")?"product_sku-quantity-label":"product_sku-desired-quantity-label")])), env.opts.autoescape);
output += ":\n\n\t    </label>\n\n        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut")) {
output += "\n\n            ";
var t_14;
t_14 = (lineno = 31, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["productControls.quantity",1]));
frame.set("desiredQuantity", t_14, true);
if(frame.topLevel) {
context.setVariable("desiredQuantity", t_14);
}
if(frame.topLevel) {
context.addExport("desiredQuantity", t_14);
}
output += "\n\n            ";
output += runtime.suppressValue((lineno = 33, colno = 36, runtime.callWrap(t_9, "productQuantityDropdown", context, [runtime.makeKeywordArgs({"id": runtime.contextOrFrameLookup(context, frame, "quantityDropdownId"),"class": "js-quantity-select c-product-quantity__select","dataAttributes": "data-qa-qty-select","desiredQuantity": runtime.contextOrFrameLookup(context, frame, "desiredQuantity")})])), env.opts.autoescape);
output += "\n\n        ";
;
}
else {
output += "\n\n            <span class=\"c-product-quantity__select--disabled\"> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productControls")),"quantity"), env.opts.autoescape);
output += " </span>\n\n        ";
;
}
output += "\n\n        ";
output += runtime.suppressValue((lineno = 41, colno = 27, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productControls")),"validation")),"messages")),"quantity"),runtime.makeKeywordArgs({"id": runtime.contextOrFrameLookup(context, frame, "quantityDropdownId")})])), env.opts.autoescape);
output += "\n\n\t</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-quantity.j2"] , dependencies)